import { PopperPlacementType } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { CfUncontrolledMenu } from './CfUncontrolledMenu';

type CfActionMenuProps = {
  anchorElement: HTMLElement | undefined;
  onClose?: () => void;
  width: number;
  dataTestId?: string;
  prefix?: ReactNode;
  placement?: PopperPlacementType;
};

export const CfActionMenu: FC<PropsWithChildren<CfActionMenuProps>> = (props: PropsWithChildren<CfActionMenuProps>) => {
  return (
    <CfUncontrolledMenu
      {...props}
      closeOnScroll
      //keepMounted={false}
      disablePortal={true}
      mode='menu'
      placement={props.placement ?? 'bottom-end'}
      variant='square'
      divider='flush'
      containerSx={{ my: 0 }}
      popperSx={{ boxShadow: '0px 2px 8px 0px #00000026' }}
    />
  );
};
